import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';
import styledC from 'styled-components';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

type FieldValueProps = StylableComponent<HTMLDivElement> & {
  value?: ReactNode;
  selecting?: boolean;
  disabled?: boolean;
  placeholder?: ReactNode;
};

type StyledDivProps = {
  value?: ReactNode;
  $selecting?: boolean;
  disabled?: boolean;
};

const StyledDiv = styledC.div<StyledDivProps>`
  display: flex;
  padding: ${theme.spacing.XXXS}px ${theme.spacing.XXS}px;
  align-items: center;
  outline: none;
  border-radius: ${theme.borderRadius.medium}px;
  background-color: ${(props) =>
    props.$selecting
      ? theme.tokens.colors.background.focused.value
      : 'transparent'};
  color: ${(props) =>
    props.value && !props.disabled
      ? theme.tokens.colors.text.primary.value
      : theme.tokens.colors.text.inactive.value};
  ${theme.typography.labelMedium}
`;

const FieldValue = React.forwardRef<HTMLDivElement, FieldValueProps>(
  ({ value, selecting, placeholder, style, ...props }, ref) => {
    return (
      <StyledDiv
        ref={ref}
        value={value}
        $selecting={selecting}
        css={style}
        {...props}
      >
        {value || placeholder}
      </StyledDiv>
    );
  },
);

FieldValue.displayName = 'FieldValue';

FieldValue.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to display, should be the formatted date(s) string(s) */
  value: PropTypes.any,
  /** Whether the field is selecting the date */
  selecting: PropTypes.bool,
  /** Placeholder to display when there is no value */
  placeholder: PropTypes.string,
  /** Whether the field is disabled */
  disabled: PropTypes.bool,
};

export default FieldValue;
